module.exports = __webpack_public_path__ + "static/media/AH.47428313.svg";